import { render, staticRenderFns } from "./paymentoptions.vue?vue&type=template&id=454c8fc1"
import script from "./paymentoptions.vue?vue&type=script&lang=js"
export * from "./paymentoptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports